<!-- Icons: https://css.gg/ -->
<div id="bottom">
  <nav>
    <div class="link" routerLink="/godmode" routerLinkActive="active">
      <img src="img/admin.svg" alt="Admin Icon" class="logo" />
    </div>
    <div class="link" routerLink="/jam" routerLinkActive="active">
      <img src="img/play-list.svg" alt="Playlist Icon" class="logo" />
    </div>
    <div class="link" routerLink="/search" routerLinkActive="active">
      <img src="img/search.svg" alt="Search Icon" class="icon" />
    </div>
  </nav>
</div>
